import styled from 'styled-components'

import { colors } from 'themes'
import ConfirmButton from 'components/Buttons/ConfirmButton'

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	background: ${colors.default.background};
	border-radius: 14px;
	
	p {
		color: var(--error-main);
		margin: 20px;
	}
`

export const OkButton = styled(ConfirmButton)`
	padding: 8px 13px; 
	border-radius: 20px;
	margin-bottom: 10px;
`
